import './NewDynaTable.scss';
import PropTypes from 'prop-types';
import {useEffect, useState} from "react";
import {formatToPersianAddComma} from "../../utils/CommaSeparator";
import numericFunction from "../../utils/NumericFunction";
import Pagination from "./Pagination/Pagination";


const DynaTable = ({
                     column,
                     data,
                     className,
                     mainWidth,
                     priceFields,
                     hasPagination,
                     rowInPage,
                     hasHeaderFilter,
                     hasOperation,
                     operationSVG,
                     operationPrintSVG,
                     operationCopySVG,
                     hasCheckBox,
                     onRowClickHandler,
                     checkBoxHandler,
                     setDataFromTable
                   }) => {

  const [componentColumn, setComponentColumn] = useState([]);
  const [componentData, setComponentData] = useState([]);
  const [temporaryData, setTemporaryData] = useState([]);
  const [fieldColumn, setFieldColumn] = useState([]);
  const [filterColumn, setFilterColumn] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [commaColumn, setCommaColumn] = useState([]);
  const [dataForFilter, setDataForFilter] = useState({});
  const [operationCount, setOperationCount] = useState(0);

  useEffect(() => {
    if (column !== undefined) {
      let temp = [...column]
      if (hasOperation) {
        let flag = 0
        temp.push({
          field: "hasOperation",
          title: "عملیات",
          visible: true,
          headerFilter: false,
        })
        if (operationSVG !== undefined) {
          flag = flag + 1
        }
        if (operationPrintSVG !== undefined) {
          flag = flag + 1
        }
        if (operationCopySVG !== undefined) {
          flag = flag + 1
        }
        setOperationCount(flag)
      }
      if (hasCheckBox) {
        temp.unshift({
          field: "hasCheckBox",
          title: "",
          visible: true,
          headerFilter: false,
        })
        setComponentColumn(temp)
      }
      setComponentColumn(temp)
      setDataForFilter({})
      setItemsPerPage(rowInPage)
    }
  }, [column, hasOperation, operationCopySVG, operationPrintSVG, operationSVG, rowInPage, hasCheckBox])

  useEffect(() => {
    if (componentColumn.length > 0) {
      let temp = []
      let tempTwo = []
      componentColumn.forEach((v) => {
        if (v.visible) {
          temp.push(v.field);

          if (v.headerFilter) {
            tempTwo.push(v.field)
          }
        }
        setFieldColumn(temp)
        setFilterColumn(tempTwo)
      });

      if (priceFields !== undefined) {
        let temp = []
        priceFields.forEach((v) => {
          temp.push(v)
        })
        setCommaColumn([...temp])
      }
    }
  }, [componentColumn, priceFields])

  //------- Pagination
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(0);
  const [pageCount, setPageCount] = useState(1)
  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
  };
  // ---------- //

  useEffect(() => {
    let dataFilter
    if (Object?.keys(dataForFilter).length === 1 && Object?.keys(dataForFilter).length > 0) {
      dataFilter = [...data]
    } else {
      dataFilter = [...temporaryData]
    }

    if (Object?.keys(dataForFilter).length > 0) {
      for (const dataForFilterKey in dataForFilter) {
        const filtered = dataFilter.filter((item) => {
          return item[dataForFilterKey]?.toString().includes(dataForFilter[dataForFilterKey])
        })
        setTemporaryData([...filtered])
      }
    } else {
      setTemporaryData([...data])
    }
  }, [data, dataForFilter]);

  useEffect(() => {
    if (temporaryData.length > 0) {
      if (hasPagination) {
        if (temporaryData.length > itemsPerPage) {
          setComponentData(temporaryData?.slice(
            currentPage * itemsPerPage,
            (currentPage + 1) * itemsPerPage
          ))
          setPageCount(Math.ceil(temporaryData.length / itemsPerPage))
        } else {
          setComponentData([...temporaryData])
        }
      } else {
        setComponentData([...temporaryData])
      }
    } else {
      setComponentData([...temporaryData])
    }
  }, [hasPagination, currentPage, itemsPerPage, temporaryData]);

  useEffect(() => {
    setDataFromTable(temporaryData)
  }, [temporaryData]);

  try {
    return (
      <div className="main-dyna-table">
        <ul className={`DynaTable ${className !== undefined ? className : ""}`}
            style={mainWidth !== undefined ? {width: mainWidth} : {}}>

          <li className="header-table">
            {componentColumn?.map((v, index) => (
              <>
                {v.visible && (
                  <span key={"H" + index} className={"table-cell"}>
                  {v.title}
                </span>
                )}
              </>
            ))}
          </li>

          {hasHeaderFilter &&
            <li className="header-filter-row">
              {componentColumn.map((q, rowIndex) =>
                q.headerFilter ?
                  filterColumn.map((v, index) =>
                    q.field === v &&
                    <span key={"In" + index} className={"table-cell"}>
                      <input value={dataForFilter?.[q.field] === undefined ? "" : dataForFilter?.[q.field]}
                             onChange={(e) => {
                               if (e.target.value !== "") {
                                 setDataForFilter({...dataForFilter, [q.field]: e.target.value})
                               } else {
                                 // eslint-disable-next-line no-unused-vars
                                 const {[q.field]: deletedKey, ...newData} = dataForFilter;
                                 setDataForFilter(newData);
                               }
                             }}/>
                    </span>) :
                  <span key={"H" + rowIndex} className={"table-cell"}></span>
              )}
            </li>
          }

          {componentData.length > 0 ? <>
            {componentData.map((rowData, index) =>
              <li key={"Row" + index} className={`middle-table ${
                JSON.stringify(rowData) === JSON.stringify(selectedRow)
                  ? "select-color"
                  : ""
              }`} onClick={() => {
                setSelectedRow(rowData);
                onRowClickHandler(rowData);
              }}>

                {fieldColumn.map((field, indexField) => {
                  return (
                    field === "hasOperation" ?
                      <span key={"F" + indexField} className="operation-cell"
                            style={operationCount === 1 ? {padding: '0 30px'} : {}}>
                      {operationPrintSVG !== undefined && <div className={"operation-svg"}>{operationPrintSVG}</div>}
                        {operationCopySVG !== undefined && <div className={"operation-svg"}>{operationCopySVG}</div>}
                        {operationSVG !== undefined && <div className={"operation-svg"}>{operationSVG}</div>}
                    </span> :
                      field === "hasCheckBox" ?
                        <span className="check-box-cell">
                          <input type={"checkbox"}
                                 checked={rowData.hasCheckBox}
                                 name={"myCheckbox" + rowData.uniqId}
                                 id={"myCheckbox" + rowData.uniqId}
                                 onChange={(e) => {
                                   checkBoxHandler(rowData, e.target)
                                 }}/>
                          <label htmlFor={"myCheckbox" + rowData.uniqId}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="7"
                              height="5"
                              fill="none"
                              viewBox="0 0 7 5"
                            >
                              <path
                                stroke="#fff"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="1.5"
                                d="M4 3.15L6.15 1M1 2.719l1.713 1.719L4.306 2.85"
                              ></path>
                            </svg>
                          </label>
                        </span> :
                        <span key={"F" + indexField}>
                      {commaColumn.includes(field) ? (
                        formatToPersianAddComma(rowData[field])
                      ) : (
                        (numericFunction.e2p(rowData[field]))
                      )}
                    </span>)
                })}
              </li>
            )}
            {hasPagination &&
              <div className="pagination-row">
                <Pagination
                  pageCount={pageCount}
                  onPageChange={handlePageChange}
                  paginationClass={"solid-pagination"}
                />
              </div>
            }
          </> : <div className="no-data-to-show"><p>اطلاعاتی موجود نسیت</p></div>}
        </ul>
      </div>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

DynaTable.propTypes = {
  column: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  className: PropTypes.string.isRequired,
  priceFields: PropTypes.array,
  hasPagination: PropTypes.bool.isRequired,
  mainWidth: PropTypes.string,
  rowInPage: PropTypes.number,
  hasOperation: PropTypes.bool.isRequired,
  operationSVG: PropTypes.object,
  operationPrintSVG: PropTypes.object,
  operationCopySVG: PropTypes.object,
  hasCheckBox: PropTypes.bool.isRequired,
  checkBoxHandler: PropTypes.func
}

export default DynaTable;